import router from '../../router/index'
import axios from 'axios';
import restJson from '../../assets/Rutas.json';

/*const baseURL = "https://servintd.latinoseguros.com.mx:8090/"; // Pruebas
const urlPago = baseURL + "sites/cobrolineaqa/common/bancos.aspx";
const idAppSas = '50084'*/

const baseURL = "https://solicitud.latinoseguros.com.mx/"; // Producción
const urlPago = baseURL + "sites/cobrolinea/common/bancos.aspx";
const idAppSas = '50084'

//const baseURL = "https://servintp.latinoseguros.com.mx:8091/"; // Producción
//const urlPago = baseURL + "sites/cobrolinea/common/bancos.aspx";
//const idAppSas = '50084'


axios.defaults.baseURL = baseURL;

export const getBaseUrl = () => baseURL;
export const geturlPago = () => urlPago;

export const login = (context, data) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/Login',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': 'F827FE82207B214D85FB0C8856B1BCB411D4'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        !redir ? 
                            router.push('/sas/dashboard')
                        : null;
                        console.log('TOKEN ID: ' + response.data.data.tokenId)
                    } else {
                        console.log(response.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}

export const loginExtern = (context, params) => {
    try {
        return new Promise((resolve, reject) => {

            const config = {
                method: 'post',
                url: 'security/api/Login',
                headers: {
                    'Content-Type': 'application/json',
                    'XAPPID': 'F827FE82207B214D85FB0C8856B1BCB411D4'
                },
                data: JSON.stringify(params)
            };

            axios(config)
                .then(function (response) {
                    if (response.status === 200) {
                        if (response.data.flag) {
                            context.commit('setToken', response.data.data.tokenId)
                            localStorage.setItem('token', response.data.data.tokenId)
                            localStorage.setItem('profileId', response.data.data.profileId)
                            localStorage.setItem('userId', response.data.data.userId)
                            resolve(response.data.flag)
                        } else {
                            resolve(response.data.flag)
                        }
                        context.commit('setFlagResponse', response.data.flag)
                    } else {
                        context.commit('setFlagResponse', false)
                    }
                    context.commit('hideLoading');
                }).catch(function (error) {
                    context.commit('hideLoading');
                    reject(error);
                });

        })

    } catch (error) {
        context.commit('hideLoading');
        // commit('loginStop', error)
    }
}

export const getToken = (context) => {
    if (localStorage.getItem('token')) {
        context.commit('setToken', localStorage.getItem('token'))
    } else {
        context.commit('setToken', null)
    }
}

export const logOut = (context) => {
    context.commit('setToken', null)
    localStorage.removeItem('token')
    localStorage.removeItem('profileId')
    router.push('/clientes/login')
}
export const logOutISep = (context) => {
    context.commit('setToken', null)
    localStorage.removeItem('token')
    localStorage.removeItem('profileId')
    router.push('/isep/login')
}

export const getTipoCambio = () => {

}

export const enableLoading = (context) => {
    context.commit('showLoading')
}

export const disabledLoading = (context) => {
    context.commit('hideLoading')
}

export const metodoPostMedia = (context, params) => {

    const { data, metodo } = params;

    const servicio = restJson.filter(ruta => ruta.metodo == metodo);

    try {
        const config = {
            method: 'post',
            url: `${servicio[0].ruta}`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'XAPPID': 'F827FE82207B214D85FB0C8856B1BCB411D4',
                'Authorization': `Bearer ${context.state.token}`,
            },
            data: data
        };

        context.commit('showLoading')
        context.commit('setLimpiadataResponse')

        return new Promise((resolve, reject) => {

            axios(config)
                .then(function(response) {
                    //console.log(response.status);
                    if (response.status === 200) {
                        if (response.data.flag) {
                            context.commit('setDataResponse', response.data.data)
                            resolve(response.data.flag)
                        } else {
                            var Modal = {
                                muestra: true,
                                color: "danger",
                                contenido: response.data.errorMessage,
                                boton: "Aceptar",
                                titulo: "Error al ejecutar " + response.config.url.split('/')[response.config.url.split('/').length - 1]
                            }

                            context.commit('showModal', Modal)
                            resolve(response.data.flag)
                            context.commit('setFlagResponse', response.data.flag)
                        }

                    } else {
                        context.commit('setFlagResponse', false)
                    }
                    context.commit('showLoading')
                })
            .catch(function(error) {
                // commit('loginStop', error)
                //console.log(error);
                var Modal = {
                    muestra: true,
                    color: "danger",
                    contenido: error,
                    boton: "Aceptar",
                    titulo: "Error al ejecutar " + error.message
                }

                context.commit('showModal', Modal)
                resolve(response.data.flag)
                context.commit('setFlagResponse', 'false')
                reject(error)
            });

        })

    } catch (error) {
        // commit('loginStop', error)
        //console.log(error);
        // commit('loginStop', error)
        //console.log(error);
        var Modal = {
            muestra: true,
            color: "danger",
            contenido: error,
            boton: "Aceptar",
            titulo: "Error al ejecutar el envío de las fotos " + error.message
        }

        context.commit('showModal', Modal)
        resolve(response.data.flag)
        context.commit('setFlagResponse', false)
    }
}

export const metodoPost = (context, params) => {
    const { data } = params;
    const { token } = data;
    try {
        // Cambia el estado de Loading a true
        context.commit('showLoading'); 
        // Limpia la respuesta anterior y los posibles mensajes de error
        context.commit('setLimpiadataResponse'); 
        getToken(context);
        context.commit('getRutas', params);
        
        return new Promise((resolve, reject) => {
            if (token) {
                context.state.config.headers.Authorization = `Bearer ${token}`;
            }

            axios(context.state.config)
                .then(function(response) {
                    context.commit('setDataRaw', response.data);
                    
                    if (response.status === 200) {
                        context.commit('setDataResponse', response.data.data);
                        context.commit('setDataRaw', response.data.errorMessage);
                        context.commit('setFlagResponse', response.data.flag);

                        resolve(response.data); 
                    } else {
                        context.commit('setFlagResponse', false);
                        context.commit('setErrorMessage', "Error en la solicitud.");
                        resolve(false);
                    }
                })
                .catch(function(error) {
                    context.commit('setFlagResponse', false);
                    context.commit('setErrorMessage', error.message || "Error en la solicitud.");
                    reject(error);
                });
        });
    } catch (error) {
        // Manejo de errores inesperados
        context.commit('setFlagResponse', false);
        context.commit('setErrorMessage', error.message || "Error inesperado.");
    }
};

export const metodoPostWithoutLoading = (context, params) => {
    const { data } = params;
    const { token } = data
    try {
        context.commit('setLimpiadataResponse')
        getToken(context)
        context.commit('getRutas', params)
        return new Promise((resolve, reject) => {
            
            if (token) {
                context.state.config.headers.Authorization = `Bearer ${token}`;
            }

            axios(context.state.config)
                .then(function(response) {
                    //console.log(response.status);
                    if (response.status === 200) {
                        context.commit('setDataRaw', response.data)
                        context.commit('setDataResponse', response.data.data)
                        if (response.data.flag) {
                            context.commit('setDataResponse', response.data.data)
                            resolve(response.data.flag)
                        } else {
                            var Modal = {
                                muestra: true,
                                color: "danger",
                                contenido: response.data.errorMessage,
                                boton: "Aceptar",
                                titulo: "Error al ejecutar " + response.config.url.split('/')[response.config.url.split('/').length - 1]
                            }

                            context.commit('showModal', Modal)
                            resolve(response.data.flag)
                            context.commit('setFlagResponse', response.data.flag)
                        }

                    } else {
                        context.commit('setFlagResponse', false)

                    }
                })
            .catch(function(error) {
                reject()
            });

        })

    } catch (error) {
        // commit('loginStop', error)
    }
}

export const loginSas = (context, data) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/Login',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': '995DFF93266223568EEC0DED5EBFBAB80CA983'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        localStorage.setItem('userId', response.data.data.userId)
                        const regex = /^[0-9]*$/;
                        const onlyNumbers = regex.test(response.data.data.userId); // true
                        console.log(onlyNumbers);
                        !redir && onlyNumbers ? 
                                router.push('/sas/inicio')
                            : router.push('/sas/inicio');
                    } else {
                        console.log(response.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}
export const loginSASP = (context, data) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/LoginVue',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': '995DFF93266223568EEC0DED5EBFBAB80CA983'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        localStorage.setItem('userId', response.data.data.userId)
                    
                    } else {
                        console.log(response.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}

export const loginISEP = (context, data) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/Login',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': 'FC229DFF50672041919A1BE949A0'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        localStorage.setItem('userId', response.data.data.userId)
                        router.push('/isep/proceso')
                        
                    } else {
                        console.log(response.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                console.log(error);
                
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}

export const loginPagoLinea = (context, data, token) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/Login',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': 'FD229DF0536A3C4988F901E453B1ACB20C'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        localStorage.setItem('userId', response.data.data.userId)

                        // !redir ? 
                        //     router.push(`/pages/app/registro/data`)
                        // : null;
                        
                    } else {
                        console.log(response.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}

export const loginValorLatino = (context, data) => {
    const { userName, password, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/Login',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': 'F827FE82207B214D85FB0C8856B1BCB411D4'
            },
            data: JSON.stringify({
                userName: userName,
                password: password
            })
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        localStorage.setItem('userId', response.data.data.userId)
                        
                    } else {
                        console.log(response.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}

export const loginDelegadoCU = (context, data, token) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/Login',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': 'F827FE82207B214D85FB0C8856B1BCB411D4'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        localStorage.setItem('userId', response.data.data.userId)
                    } else {
                        console.log(response.data.errorMessage);
                    }
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}
export const loginSeguridad = (context, data) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/Login',
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': 'F827FE82207B214D85FB0C8856B1BCB411D4'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setTokenSeguridad', response.data.data.tokenId)
                        localStorage.setItem('tokenSeguridad', response.data.data.tokenId)
                    
                    } else {
                        console.log(response.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}

export const setPolizaData = (context, data) => {
    context.commit("SET_POLIZA_DATA", data); // Llama a una mutación para almacenar los datos
  };
  
  export const getPolizaData = (context) => {
    return context.getters.getPolizaData; // Recupera los datos usando un getter
  };

  export const setSelectedEndosos = (context, endosos) => {
    context.commit("SET_SELECTED_ENDOSOS", endosos);
  };
  export const toggleSelectedEndoso = (context, endoso) => {
    if (endoso && endoso.pEndoso) {
        context.commit("SET_SELECTED_ENDOSO", endoso);
    } else {
        console.error("El objeto endoso no tiene el formato esperado:", endoso);
    }
};
export const resetSelectedEndosos = (context) => {
    context.commit("RESET_SELECTED_ENDOSOS");
  };

  export const guardaDatosPolizaProvenientesUrl = ({ commit }, datos) => {
    try {
        if (datos) {
            commit("setDatosPolizaProvenientesUrl", datos); // Guarda los datos directamente
            console.log("Datos guardados en la store:", datos);
            return datos;
        } else {
            console.warn("No se encontró 'datos' en el payload.");
            return null;
        }
    } catch (error) {
        console.error("Error al guardar los datos de la póliza:", error);
        throw error;
    }
}